enum DATE_FORMAT {
    DE = 'dd.MM.yyyy',
    US = 'M/d/yyyy',
    EN = 'dd/MM/yyyy',
    DE_LONG = 'dd.MMMM.yyyy',
    US_LONG = 'MMMM d, yyyy',
    EN_LONG = 'dd MMMM yyyy',
    DE_SHORT = 'dd.MM.yy',
    US_SHORT = 'M/d/yy',
    EN_SHORT = 'dd/MM/yy',
    INPUT = 'yyyy-MM-dd'
}

enum TIME_FORMAT {
    DE = 'HH:mm',
    DE_LONG = 'HH:mm:ss',
    US = 'H:MM a',
    US_LONG = 'H:MM:ss a'
}

enum DATE_TIME_FORMAT {
    DE = 'dd.MM.yyyy HH:mm',
    DE_SHORT = 'dd.MM.yy HH:mm'
}

type ISO = 'iso'
type NOW = 'now'

type LUXON_FORMAT = DATE_FORMAT | TIME_FORMAT | DATE_TIME_FORMAT | ISO
export {
    DATE_FORMAT,
    DATE_TIME_FORMAT,
    TIME_FORMAT,
    LUXON_FORMAT,
    ISO,
    NOW
}
